import { useContext } from 'react';
import { CompanyContext } from '../contexts/CompanyContext';
import { GetOtherReviews } from './ThankYouPageOptions/GetOtherReviews';
import { RedirectToUrl } from './ThankYouPageOptions/RedirectToUrl';
import { FallbackThankYouPage } from './ThankYouPageOptions/FallbackThankYouPage';
import { ThankYouShare } from './ThankYouPageOptions/ThankYouShare';
import { ReviewContext } from '../contexts/ReviewContext';
import { getThankYouPage } from '../services/ReviewProcessService';
import { CompanyThankYou } from '../types/ApiTypes';
import { ReferralForm } from "./ThankYouPageOptions/ReferralForm";
import {clarityEvent} from "../services/UtilService";

export function ThankYouPage(): JSX.Element {
  const { company } = useContext(CompanyContext);
  const { review } = useContext(ReviewContext);

  clarityEvent("Completed Review")

  const thankYouPageFormat: CompanyThankYou['sharingFormat'] =
    company && review
      ? getThankYouPage(
          company.thankYou.sharingFormat,
          review.stars,
          company.minStarAllowExternal,
        )
      : null;

  if (thankYouPageFormat == 0) {
    return <GetOtherReviews />;
  } else if(thankYouPageFormat == 1) {
    return (
        <ThankYouShare url={review?.reviewUrl ? review.reviewUrl : "https://sotellus.com"} isOffer={false}/>
    )
  } else if (thankYouPageFormat == 2) {
    return (
      <ThankYouShare
        url={review?.reviewUrl ? review.reviewUrl + 'offer/' : 'https://sotellus.com'}
        isOffer={thankYouPageFormat === 2 ? true : false}
      />
    );
  } else if(thankYouPageFormat == 3) {
    return (
        <ReferralForm
           url={review?.reviewUrl ? review.reviewUrl : 'https://sotellus.com'}
        />
    )
  } else if (thankYouPageFormat == 4) {
    return (
      <RedirectToUrl
        url={
          company?.thankYou?.redirectUrl
            ? company.thankYou.redirectUrl
            : 'https://sotellus.com'
        }
      />
    );
  } else {
    return <FallbackThankYouPage />;
  }
}
